import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, onChange, noUpperCase, ...props }, ref) => {
  // Handle uppercase conversion (unless disabled)
  const handleChange = (e) => {
    if (!noUpperCase && e.target && typeof e.target.value === 'string') {
      e.target.value = e.target.value.toUpperCase();
    }
    
    if (onChange) {
      onChange(e);
    }
  };

  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm uppercase",
        className
      )}
      ref={ref}
      onChange={handleChange}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
